export default __webpack_public_path__ + "static/media/001-chicken.1cce39d4.svg";